import { render } from "./CardNewsTemplateLeft.vue?vue&type=template&id=2f75b904&scoped=true"
import script from "./CardNewsTemplateLeft.vue?vue&type=script&lang=js"
export * from "./CardNewsTemplateLeft.vue?vue&type=script&lang=js"

import "./CardNewsTemplateLeft.vue?vue&type=style&index=0&id=2f75b904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f75b904"]])

export default __exports__